import { MISC_SET_CONFIG } from 'constants/ActionTypes';
const configReducer = (state = {}, action) => {
    switch (action.type) {
        case MISC_SET_CONFIG: {
            return Object.assign(Object.assign({}, state), action.data);
        }
        default:
            return state;
    }
};
export default configReducer;
